import { convertTaskFromServer } from "../../utils/task";
import { SET_ASSIGNED_TASKS, SET_ASSIGNED_TASKS_LOADING } from "../constants";
const reducer = (state, action) => {
    switch (action.type) {
        case SET_ASSIGNED_TASKS: {
            const assignedTasks = action.payload.map(convertTaskFromServer);
            return Object.assign(Object.assign({}, state), { assignedTasks, loading: false });
        }
        case SET_ASSIGNED_TASKS_LOADING: {
            const loading = action.payload;
            return Object.assign(Object.assign({}, state), { loading });
        }
        default: {
            return state;
        }
    }
};
export { reducer };
